import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    UPDATE_DOCTOR_DETAIL,
    updateDoctorDetailFail,
    updateDoctorDetailSuccess
} from '../action/updateDoctorDetailAction'

// api 
import updateDoctorDetailApi from '../api/updateDoctorDetailApi'

export function* updateDoctorDetailSaga(action) {
    try {
        const response = yield call(() => updateDoctorDetailApi(action.params))
        console.log("upsaga",response)
        if (response.data.statusCode === 200) {
            console.log("Lalit")
            yield put(updateDoctorDetailSuccess(response, action))
        } else {
            console.log("Gandhi")
            yield put(updateDoctorDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(updateDoctorDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(UPDATE_DOCTOR_DETAIL, updateDoctorDetailSaga)
}
